import React, { useEffect, useState } from "react";
import { isPrerender } from "../utils/prerender";

const STORAGE_KEY = "jsp-consent";
const CLARITY_ID = "i5vszlfmty";

const readChoice = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch (e) {
    return null;
  }
};

const storeChoice = (value) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch (e) {
    // storage unavailable (private mode, blocked): the choice lasts for this page view only
  }
};

const loadClarity = () => {
  if (window.__clarityLoaded) return;
  window.__clarityLoaded = true;
  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", CLARITY_ID);
  window.clarity("consent");
};

const grant = () => {
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", { analytics_storage: "granted" });
  }
  loadClarity();
};

const ConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isPrerender()) return;
    const choice = readChoice();
    if (choice === "granted") {
      // index.html restores the Consent Mode state; only Clarity needs loading
      loadClarity();
    } else if (choice !== "denied") {
      setVisible(true);
    }
  }, []);

  if (!visible || isPrerender()) return null;

  const accept = () => {
    storeChoice("granted");
    grant();
    setVisible(false);
  };

  const decline = () => {
    storeChoice("denied");
    setVisible(false);
  };

  return (
    <div
      role="region"
      aria-label="Cookie consent"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-gray-700 bg-gray-900 px-4 py-4 text-gray-100 shadow-lg"
    >
      <div className="mx-auto flex max-w-screen-xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm">
          We use cookies for analytics to understand how the site is used and
          improve it. Read our{" "}
          <a
            href="/privacy"
            className="underline hover:text-gray-300 focus:outline-none focus:ring-2 focus:ring-white"
          >
            Privacy Policy
          </a>
          .
        </p>
        <div className="flex flex-shrink-0 gap-3">
          <button
            type="button"
            onClick={decline}
            className="rounded border border-gray-400 px-4 py-2 text-sm font-semibold hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-white"
          >
            Decline
          </button>
          <button
            type="button"
            onClick={accept}
            className="rounded bg-primary-500 px-4 py-2 text-sm font-semibold text-white hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-white"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsentBanner;
